import { Auth } from "@supabase/auth-ui-react";
import { useSupabase } from "../../contexts/SupabaseContext";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Session } from "@supabase/supabase-js";
import { useEffect, useState } from "react";
import img from "../../assets/loginPageimage.jpg";
import { Spinner } from "@asez/component-library";
import { STATIC_STRINGS } from "@asez/shared";

export default function AuthComponent() {
  const { supabase, session, loading: sessionLoading } = useSupabase();
  const navigate = useNavigate();
  const location = useLocation();
  const [isImgLoaded, setIsImgLoaded] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const from = (location.state as { from?: string })?.from || "/";

  // Handle auth state changes
  useEffect(() => {
    if (!sessionLoading && session) {
      navigate(from, { replace: true });
    }
  }, [session, sessionLoading, navigate, from]);

  // Preload the image
  useEffect(() => {
    const imageLoader = new Image();
    imageLoader.onload = () => {
      setIsImgLoaded(true);
    };
    imageLoader.src = img;
  }, []);

  // Set page loading state based on all loading conditions
  useEffect(() => {
    if (!sessionLoading && isImgLoaded) {
      // Add a small delay for smoother transition
      const timer = setTimeout(() => {
        setPageLoading(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [sessionLoading, isImgLoaded]);

  // Full page loading state
  if (pageLoading) {
    return (
      <div className="flex items-center justify-center h-[100vh]">
        <Spinner size={32} />
      </div>
    );
  }

  if (!session) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-indigo-500 bg-opacity-80 relative overflow-hidden">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl flex overflow-hidden relative z-10">
          <div className="w-2/5 p-8 flex items-center justify-center">
            <div className="relative w-full">
              <img src={img} alt="Login illustration" className="w-full" />
            </div>
          </div>

          <div className="w-3/5 p-8 h-96 overflow-hidden">
            <div className="mb-6">
              <h1 className="text-4xl font-bold text-primary">
                {STATIC_STRINGS.LOGIN_PAGE_HEADER}
              </h1>
            </div>

            <div className="auth-container">
              <Auth
                supabaseClient={supabase}
                appearance={{
                  extend: false,
                  className: {
                    button: "btn-primary w-full rounded-md py-2",
                    container: "flex flex-col",
                    input:
                      "w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none mb-2 mt-1",
                    label: "font-medium",
                    anchor: "flex justify-center hover:text-blue-900 mt-1",
                  },
                }}
                providers={[]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <Navigate to={from} replace />;
}
